import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import QRCode from 'react-qr-code';
import { useTranslation } from 'react-i18next';
import { CheckIcon, MyAndroidIcon, MyAppleIcon } from '@guryou/html-components';

const DEFAULT_CONFIG = {
  name: 'Guryou',
  iosUrl: process.env.REACT_APP_APPLE_STORE_FEEL,
  androidUrl: process.env.REACT_APP_ANDROID_STORE_FEEL,
  isWhiteLabel: false,
};

const AppDownloadSuccess = ({ appConfig }) => {
  const { t } = useTranslation();

  const config = {
    ...DEFAULT_CONFIG,
    ...appConfig,
  };

  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);
  const isMobile = isIOS || isAndroid;

  const history = useHistory();
  const [qrType, setQrType] = useState('android');

  // if (!appConfig) return null;

  const iosLink = config.iosUrl;
  const androidLink = config.androidUrl;

  const primaryLink = isIOS ? iosLink : isAndroid ? androidLink : null;
  const qrValue = qrType === 'ios' ? iosLink : androidLink;

  return (
    <div className="w-full max-w-md mx-auto text-center text-white">
      <div className="w-14 h-14 mx-auto mb-5 rounded-full bg-emerald-500/15 flex items-center justify-center border border-emerald-400/30">
        <span className="text-emerald-400 text-2xl">
          <CheckIcon />
        </span>
      </div>

      <h2 className="text-2xl font-semibold text-white">{t('ONBOARDING_SUCCESS.accountCreated')}</h2>

      <p className="text-sm text-gray-400 mt-2">{t('ONBOARDING_SUCCESS.continueOn', { appName: config.name })}</p>

      <div className="mt-7 rounded-2xl p-5 bg-white/5 border border-white/10 backdrop-blur-md">
        <p className="text-sm text-gray-300 mb-4">{t('ONBOARDING_SUCCESS.downloadApp')}</p>

        {isMobile ? (
          <>
            {primaryLink && (
              <a href={primaryLink} className="block w-full bg-white text-black py-3 rounded-xl font-semibold">
                {isIOS ? t('ONBOARDING_SUCCESS.downloadIOS') : t('ONBOARDING_SUCCESS.downloadAndroid')}
              </a>
            )}
          </>
        ) : (
          <>
            <div className="flex gap-2 mb-4">
              {iosLink && (
                <button
                  onClick={() => setQrType('ios')}
                  className={`flex-1 py-2 rounded-lg text-sm border transition ${
                    qrType === 'ios' ? 'bg-white text-black border-white' : 'border-white/20 text-gray-300 hover:bg-white/10'
                  }`}
                >
                  <span className="flex items-center justify-center gap-2">
                    <MyAppleIcon className="w-4 h-4" />
                    <span>{t('ONBOARDING_SUCCESS.ios')}</span>
                  </span>
                </button>
              )}

              {androidLink && (
                <button
                  onClick={() => setQrType('android')}
                  className={`flex-1 py-2 rounded-lg text-sm border transition ${
                    qrType === 'android' ? 'bg-white text-black border-white' : 'border-white/20 text-gray-300 hover:bg-white/10'
                  }`}
                >
                  <span className="flex items-center justify-center gap-2">
                    <MyAndroidIcon className="w-4 h-4" />
                    <span>{t('ONBOARDING_SUCCESS.android')}</span>
                  </span>
                </button>
              )}
            </div>

            <div className="flex flex-col items-center">
              <p className="text-xs text-gray-400 mb-2">
                {t('ONBOARDING_SUCCESS.scanToDownload', {
                  platform: qrType === 'ios' ? t('ONBOARDING_SUCCESS.ios') : t('ONBOARDING_SUCCESS.android'),
                })}
              </p>

              <div className="bg-white p-2 rounded-xl">
                <QRCode value={qrValue} size={160} />
              </div>
            </div>

            <div className="mt-2">
              <a href={qrValue} target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 underline">
                {t('ONBOARDING_SUCCESS.openDownloadLink')}
              </a>
            </div>
          </>
        )}
      </div>

      <button onClick={() => history.push('/')} className="mt-6 text-sm text-gray-400 underline hover:text-gray-200">
        {t('ONBOARDING_SUCCESS.continueWeb')}
      </button>
    </div>
  );
};

export default AppDownloadSuccess;
